import { Maybe, TemplateFieldTypeEnum } from '@/__generated__/graphql';
import { ColorPickerTrigger } from '@/components/shared/ColorPickerTrigger';
import { CustomField } from '@/components/shared/CustomField';
import { NOT_APPLICABLE_LABEL } from '@/constants';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { Stack, Typography } from '@mui/material';

export const TemplateFields = ({
  placeholder,
  label,
  value,
  endAdornment,
  mode,
  onChange = (argument0: string) => {
    return argument0;
  },
  type = TemplateFieldTypeEnum.Input,
}: {
  placeholder?: string;
  label?: string;
  value: string | undefined | Maybe<string>;
  endAdornment?: 'image' | 'color' | undefined;

  mode: 'Edit' | 'ReadOnly';
  type?: TemplateFieldTypeEnum;
  onChange?: (value: string) => void;
}) => {
  return (
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      width="100%"
      maxWidth="50rem"
      justifyContent={'space-between'}
    >
      {label && <Typography>{label}</Typography>}
      <Stack direction="row" maxWidth="30rem" gap={1} width="100%" alignItems="center">
        <CustomField
          placeholder={placeholder}
          fieldId={label}
          mode={mode}
          sx={{ textAlign: 'end' }}
          initialValue={value ?? NOT_APPLICABLE_LABEL}
          onChange={onChange}
          fieldType={type}
        />
        {value && endAdornment === 'image' && (
          <img src={getCloudfrontUrl(value)} crossOrigin="use-credentials" alt="input-image" />
        )}
        {endAdornment === 'color' && (
          <ColorPickerTrigger color={value ?? 'fff'} onChange={(newColor) => onChange(newColor)} />
        )}
      </Stack>
    </Stack>
  );
};
